export { D as Dialog, P as PageHeader } from './PageHeader-DCDIR2C1.js';
export { T as Tooltip } from './Tooltip-YuSlJ5b_.js';
import { UnderlinePanels as UnderlinePanels$1 } from '@primer/react/experimental';
export { Table } from '@primer/react/experimental';
import styled from 'styled-components';
import { sx } from '@primer/react';
import { jsx } from 'react/jsx-runtime';
import 'react';
import '@primer/react/deprecated';

const StyledUnderlinePanels = styled(UnderlinePanels$1).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "UnderlinePanels__StyledUnderlinePanels",
  componentId: "sc-1w35i85-0"
})(["", ""], sx);

// @ts-ignore forwardedAs is valid here but I don't know how to fix the typescript error
const UnderlinePanelsImpl = ({
  as,
  ...props
}) => /*#__PURE__*/jsx(StyledUnderlinePanels, {
  forwardedAs: as,
  ...props
});
UnderlinePanelsImpl.displayName = 'UnderlinePanels';
const UnderlinePanels = Object.assign(UnderlinePanelsImpl, {
  Tab: UnderlinePanels$1.Tab,
  Panel: UnderlinePanels$1.Panel
});

export { UnderlinePanels };
